<template>
  <div class="detail-wrap">
    <div class="top-header-bj" :style="{ background: colors(detailData.status) }"></div>
    <div class="top-header">
      <h4>{{ orderStatus(detailData.status) }}</h4>
      <div class="time" v-if="detailData.count_down_str">
        {{ detailData.count_down_str }}
      </div>
    </div>
    <div
      class="order-experience"
      v-if="detailData.status != -1 && detailData.status != 11 && detailData.status != 12"
    >
      <div class="title">{{ detailData.notice_str }}</div>
      <div class="btns">
        <!-- 代付款 -->
        <div class="btn1" v-if="detailData.status == 0" @click="cancelOrder">
          取消订单
        </div>
        <div class="btn1 pay" v-if="detailData.status == 0" @click="pay">
          立即付款
        </div>
        <!-- status = 1 是待审核 -->
        <div class="btn1" v-if="detailData.status == 1" @click="cancelOrder">
          取消订单
        </div>
        <!--待作业 -->
        <div class="btn1" v-if="detailData.status == 2" @click="cancelOrder">
          取消订单
        </div>
        <!--待作业 -->
        <div class="btn1" v-if="detailData.status == 3" @click="cancelOrder">
          取消订单
        </div>
        <div class="btn3" @click="feedback" v-if="detailData.status == 4">
          问题反馈
        </div>
        <div class="btn1 pay" v-if="detailData.status == 4" @click="lookMap">
          查看轨迹
        </div>
        <div class="btn1 pay" v-if="detailData.status == 3" @click="warmWork(null)">
          提醒作业
        </div>
        <div class="btn5" v-if="detailData.status == 2" @click="warmWork(null)">
          提醒接单
        </div>
        <div class="btn1" v-if="detailData.status == 5" @click="lookMap">
          查看轨迹
        </div>
        <div class="btn1" v-if="detailData.status == 5" @click="feedback">
          问题反馈
        </div>
        <div class="btn1 pay" v-if="detailData.status == 5" @click="check">
          确认验收
        </div>
        <div
          class="btn1"
          v-if="detailData.status == 10 && detailData.is_have_comment == 0"
          @click="goToRate"
        >
          评价
        </div>
        <div
          class="btn1"
          v-if="detailData.status == 10 && detailData.is_have_comment == 1"
          @click="goToRated"
        >
          已评价
        </div>
        <div class="btn1" v-if="detailData.status == 10" @click="feedback">
          问题反馈
        </div>
        <div class="btn2 btn4" @click="makeInvoice" v-if="detailData.is_get_invote">
          已开票
          <van-icon name="warning-o" color="#656565" />
        </div>
      </div>
    </div>
    <div
      class="refund-bar"
      v-if="
        detailData.status == 11 ||
          detailData.status == 12 ||
          (detailData.status == 10 && detailData.refund_status == 1) ||
          (detailData.status == 10 && detailData.refund_status == 2) ||
          (detailData.status == 10 && detailData.refund_status == -1)
      "
      :class="{ top: detailData.status == 11 || detailData.status == 12 }"
      @click="goToRefundDetail"
    >
      <!-- 已完成 特有退款栏目 -->
      <div class="left">退款详情</div>
      <div class="right">
        {{ orderStatus(detailData.status, detailData.refund_status) }}
      </div>
      <div class="icon">
        <van-icon name="arrow" />
      </div>
    </div>
    <div
      class="fly-area"
      v-if="
        detailData.status != 0 &&
          detailData.status != 1 &&
          detailData.status != 2 &&
          detailData.status != 3 &&
          detailData.status != 4 &&
          detailData.status != -1 &&
          detailData.status != 11 &&
          detailData.status != 12
      "
      @click="gotoFlyHistory"
    >
      <div class="img"></div>
      <div class="list">
        <div class="item">
          <span class="item-title"
            >实飞面积<i class="title-num">{{ detailData.total_work_mu }}亩</i></span
          >
          <span class="item-number" v-show="flyArea != 0">
            <van-icon name="down" class="up" v-if="flyArea >= 0" />
            <van-icon name="down" class="down" v-else />
            比预估{{ flyArea < 0 ? '少' : '多'
            }}<i :class="{ orange: flyArea > 0, green: flyArea < 0 }">{{
              flyArea < 0 ? -flyArea : flyArea
            }}</i
            >亩
          </span>
        </div>
        <div class="item">
          <span class="item-title"
            >无人机共<i class="black">{{ detailData.total_plane_count }}</i
            >台</span
          >
        </div>
        <div class="item">
          <span class="time">{{ detailData.start_time }} — {{ detailData.end_time }}</span>
        </div>
      </div>
      <div class="right-icon">
        <van-icon name="arrow" />
      </div>
    </div>
    <div
      class="flyer-box"
      v-if="
        detailData.status != 0 &&
          detailData.status != 1 &&
          detailData.status != -1 &&
          detailData.status != 11 &&
          detailData.status != 12
      "
    >
      <div class="title">飞手信息</div>
      <ul class="flyer-ul">
        <li v-for="(item, index) in detailData.groups" :key="index">
          <div class="name-title">飞手姓名</div>
          <div class="img">
            <div class="img-box"><img :src="item.avatar" /></div>

            <span class="name">{{ item.nickname }}</span>
            <a :href="'tel:' + item.mobile" class="tel">
              <van-icon name="phone-o" />
            </a>
          </div>
          <div class="tip">
            <van-icon
              name="warning-o"
              v-if="detailData.status != 4 && detailData.status != 3 && item.status != 4"
            />
            <span v-if="detailData.status != 4 && detailData.status != 3">{{
              flyerStatus(item.status)
            }}</span>
            <div
              class="btn"
              v-if="detailData.status == 4 && item.status == 2"
              @click="warmWork(item.mid)"
            >
              提醒开始
            </div>
            <div
              class="btn"
              v-if="detailData.status == 4 && item.status == 3"
              @click="warmWork(item.mid)"
            >
              提醒结束
            </div>
          </div>
        </li>
      </ul>
      <div class="team" v-if="detailData.group_name">
        <div class="name-title">团队名称</div>
        <div class="names">{{ detailData.group_name }}</div>
      </div>
    </div>
    <div class="detail-content" :class="{ top: detailData.status == -1 }">
      <div class="info-box">
        <div class="img-box"><img :src="detailData.crop_image" /></div>
        <div class="name">{{ detailData.crop_name }}</div>
        <div class="text">
          <p class="p1">¥{{ detailData.one_price }}/亩</p>
          <p class="p2">×{{ detailData.total_mu }}亩</p>
          <p class="p3">
            {{ detailData.status == 12 ? '预付款' : '合计' }}:<span class="number"
              >¥{{ detailData.total_price }}</span
            >
          </p>
        </div>
      </div>
      <div class="address-list">
        <div class="title">作业地址 {{ adslength }}</div>
        <div class="address-item" v-for="item in detailData.address">
          <van-icon name="location-o" />
          <div class="address-text">{{ item.region }}{{ item.address }} {{ item.mu }}亩</div>
        </div>

        <div class="time-box">
          <div class="title">开始时间</div>
          <div class="times">
            <p class="p1">{{ detailData.start_time }}</p>
            <p class="p2">{{ detailData.date_str }}</p>
          </div>
        </div>
        <div class="kids-box">
          <div class="title">用药品种</div>
          <div class="content">
            <div class="item" v-html="detailData.durgs"></div>
            <!-- <div class="item">商品5种： 药品名称药品名称药品名称药品名称 药</div> -->
          </div>
        </div>
        <div class="ps-box">
          <div class="title">备注</div>
          <div class="content">{{ detailData.remark }}</div>
        </div>
      </div>
      <div class="refund-bar feedback-bar" v-if="detailData.feedback_count" @click="goToFeedback">
        <!-- 已完成 问题反馈记录栏目 -->
        <div class="left">问题反馈记录</div>
        <div class="right">{{ detailData.feedback_count }}</div>
        <div class="icon">
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="order-info-box">
        <div class="title">订单信息</div>
        <div class="item">
          <div class="babel">订单编号</div>
          <div class="text">
            {{ detailData.order_sn }}
            <span class="copy" :data-clipboard-text="detailData.order_sn" @click="copyLink"
              >复制</span
            >
          </div>
        </div>
        <div class="item" v-show="detailData.pay_type">
          <div class="babel">支付方式</div>
          <div class="text">{{ detailData.pay_type }}</div>
        </div>
        <div class="item" v-show="detailData.trade_no">
          <div class="babel">交易单号</div>
          <div class="text">{{ detailData.trade_no }}</div>
        </div>
        <div class="item">
          <div class="babel">下单时间</div>
          <div class="text">{{ detailData.create_time }}</div>
        </div>
        <div class="item" v-if="detailData.pay_time">
          <div class="babel">支付时间</div>
          <div class="text">{{ detailData.pay_time }}</div>
        </div>
        <div class="item" v-if="detailData.start_time">
          <div class="babel">开始时间</div>
          <div class="text">{{ detailData.start_time }}</div>
        </div>
        <div class="item" v-if="detailData.end_time">
          <div class="babel">结束时间</div>
          <div class="text">{{ detailData.end_time }}</div>
        </div>
        <div class="item" v-if="detailData.accept_time">
          <div class="babel">验收时间</div>
          <div class="text">{{ detailData.accept_time }}</div>
        </div>
        <div class="item" v-if="detailData.close_time">
          <div class="babel">取消时间</div>
          <div class="text">{{ detailData.close_time }}</div>
        </div>
        <!-- <div
          class="item"
          v-if="detailData.close_time"
        >
          <div class="babel">退款时间</div>
          <div class="text">detailData.close_time</div>
        </div> -->
      </div>
    </div>
    <van-dialog
      v-model="show"
      title="我要反馈"
      show-cancel-button
      confirmButtonColor="#55CC99"
      cancelButtonColor="#999999"
      :beforeClose="beforeClose"
    >
      <van-radio-group
        v-model="radio"
        direction="horizontal"
        class="radio-box"
        v-show="1"
        v-if="detailData.status != 4 && detailData.refund_status == 0"
      >
        <van-radio name="1" checked-color="#55CC99">申请退款</van-radio>
        <van-radio name="2" checked-color="#55CC99">其他反馈</van-radio>
      </van-radio-group>
      <van-field
        v-model="feedbackMessage"
        border
        maxlength="20"
        rows="3"
        autosize
        type="textarea"
        :placeholder="placeholder"
        show-word-limit
        class="feedback-textarea-01"
      />
    </van-dialog>
    <van-dialog
      v-model="orderShowFlag"
      title="取消订单"
      show-cancel-button
      confirmButtonColor="#55CC99"
      cancelButtonColor="#999999"
      :beforeClose="beforeCloseOrder"
      :class="{ noMargin: this.detailData.status == 0 }"
    >
      <van-field
        v-if="this.detailData.status != 0"
        v-model="cancelOrderContent"
        border
        maxlength="20"
        rows="3"
        autosize
        type="textarea"
        placeholder="请填写取消原因"
        show-word-limit
        class="feedback-textarea-01"
      />
    </van-dialog>
    <van-dialog
      v-model="dialog"
      title="确认验收?"
      show-cancel-button
      :confirm-button-text="confirmText"
      confirm-button-color="#55CC99"
      :show-cancel-button="showBtn"
      :close-on-click-overlay="overlay"
      :before-close="beforeCloseMakeSure"
    >
      <div class="dialog-box">
        <p class="p1">
          {{
            dialogDataMakeSure.balance == 0
              ? '实际飞行面积=订单面积，请直接验收'
              : dialogDataMakeSure.balance > 0
              ? '实飞面积>订单面积，请支付差额'
              : '退回金额将原路返回'
          }}
        </p>
        <ul v-if="dialogDataMakeSure.balance != 0">
          <li>
            <span>订单面积</span
            ><span :class="{ gray: dialogDataMakeSure.balance < 0 }"
              >{{ dialogDataMakeSure.total_mu }}亩</span
            >
          </li>
          <li>
            <span>实飞面积</span
            ><span :class="{ gray: dialogDataMakeSure.balance > 0 }"
              >{{ dialogDataMakeSure.true_mu }}亩</span
            >
          </li>
          <li>
            <span>作物单价</span><span>{{ dialogDataMakeSure.one_price }}元/亩</span>
          </li>
          <li>
            <span>{{ dialogDataMakeSure.balance < 0 ? '支付金额' : '退回金额' }}</span>
            <span
              :class="{
                orange: dialogDataMakeSure.balance > 0,
                green: dialogDataMakeSure.balance < 0,
              }"
              >¥{{ dialogDataMakeSure.balance }}</span
            >
          </li>
        </ul>
      </div>
    </van-dialog>
    <Pay
      ref="pay"
      :directPay="directPay"
      :order="detailData.order_sn"
      :money="parseFloat(detailData.total_price)"
    ></Pay>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import axios from '../../http';
import Pay from '../../components/pay/pay';
export default {
  name: 'order_detail',
  components: { Pay },
  props: {},
  inject: ['reload'],
  data() {
    return {
      feedbackMessage: '', //反馈内容
      radio: '1', // 反馈选择按钮
      show: false,
      detailData: '', //订单详情页数据
      orderShowFlag: false, //取消订单弹窗 model
      cancelOrderContent: '', //取消订单原因
      directPay: true, //true 为支付订单，false为验收订单
      dialogDataMakeSure: '',
      dialog: false,
      overlay: true, //是否显示遮罩层点击
    };
  },
  computed: {
    ...mapState(['token']),
    confirmText() {
      //确定按钮文案
      if (this.dialogDataMakeSure.balance > 0) {
        return '确认支付';
      } else {
        return '确认验收';
      }
    },
    showBtn() {
      //是否显示取消按钮
      if (this.dialogDataMakeSure.balance < 0) {
        return false;
      } else {
        return true;
      }
    },
    flyArea() {
      //飞行面积
      // let num = 0;
      // if (this.detailData.fly_data) {
      //   this.detailData.fly_data.forEach(el => {
      //     num += el.work_mu;
      //   });
      // }
      let result = (this.detailData.total_work_mu - this.detailData.total_mu).toFixed(2);
      return result;
    },
    adslength() {
      //作业地址数量
      if (this.detailData.address) {
        return this.detailData.address.length;
      }
    },
    placeholder() {
      let ploce = this.radio == '1' ? '请填写退款原因' : '请填写反馈的内容';
      if (this.detailData.status == 4 || this.detailData.refund_status != 0) {
        ploce = '请填写反馈的内容';
      }
      return ploce;
    },
  },
  watch: {},
  mounted() {
    this.getDetailData();
  },
  destroyed() {},
  methods: {
    feedback() {
      //反馈问题
      this.show = true;
    },
    flyerStatus(number) {
      let text = '';
      switch (number) {
        // -1：已拒绝 1：待处理 2：已接受 3：作业中 4：作业完成
        case -1:
          text = '已拒绝';
          break;
        case 1:
          text = '待接单';
          break;
        case 2:
          text = '已拒绝';
          break;
        case 3:
          text = '作业中';
          break;
        case 4:
          text = '';
          break;
        case -2:
          text = '未作业';
          break;
      }
      return text;
    },
    orderStatus(number, refund) {
      //订单状态对应的文案
      let text = '';
      if (refund && refund == 1 && number == 10) {
        text = '退款中...';
        return text;
      }
      if (refund && refund == 2 && number == 10) {
        text = '退款成功';
        return text;
      }
      if (refund && refund == -1 && number == 10) {
        text = '退款失败';
        return text;
      }
      switch (number) {
        case 0:
          text = '待付款';
          break;
        case 1:
          text = '待审核';
          break;
        case 2:
          text = '待接单';
          break;
        case 3:
          text = '待作业';
          break;
        case 4:
          text = '作业中...';
          break;
        case 5:
          text = '待验收';
          break;
        case 10:
          text = '已完成';
          break;
        case 11:
          text = '退款中...';
          break;
        case 12:
          text = '退款成功';
          break;
        case -1:
          text = '交易取消';
          break;
      }
      return text;
    },
    getDetailData() {
      //获取订单详情数据
      axios
        .fetchPost('/api/order/detail', {
          token: this.token,
          order_sn: this.$route.query.orderNumber,
        })
        .then((res) => {
          let data = res.data;
          if (data.code == 200) {
            this.detailData = data.data;
          }
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    copyLink() {
      //复制订单号
      let _this = this;
      let clipboard = new this.clipboard('.copy');
      clipboard.on('success', function() {
        _this.$toast('复制成功');
      });
      clipboard.on('error', function() {
        _this.$toast('复制失败');
      });
    },
    makeInvoice() {
      //已开票据 弹窗
      this.$toast('您的订单已开具过发票， 您可去“开票记录”查看发票信息');
    },
    colors(number) {
      //背景颜色选择
      let color = '';
      switch (number) {
        case 0:
          color = '#FF9922';
          break;
        case 1:
          color = '#5B86E5';
          break;
        case 2:
          color = '#55ACCC';
          break;
        case 3:
          color = '#93CC55';
          break;
        case 4:
          color = '#CECC33';
          break;
        case 5 || 6 || 7 || 10 || 11 || 12 || 13:
          color = '#55CC99';
          break;
      }
      return color;
    },
    goToFeedback() {
      //点击去到反馈记录历史
      this.$router.push({
        path: '/feedbackHistory',
        query: { order_sn: this.detailData.order_sn },
      });
    },
    gotoFlyHistory() {
      //点击去飞行记录
      const groups = this.detailData.groups;
      // if (groups.length >= 2) {
      //   this.$router.push({
      //     path: "/flyHistory",
      //     query: {
      //       order_sn: this.detailData.order_sn
      //     }
      //   });
      // } else {
      this.$router.push({
        path: '/flyDataOne',
        query: {
          order_sn: this.detailData.order_sn,
          user_id: groups[0].mid,
        },
      });
      // }
    },
    goToRate() {
      //点击去评价
      let val = JSON.stringify(this.detailData.groups);
      this.$router.push({
        path: '/rate',
        query: {
          order_sn: this.detailData.order_sn,
          groups: val,
        },
      });
    },
    goToRated() {
      this.$router.push({
        path: '/rated',
        query: { order_sn: this.detailData.order_sn },
      });
    },
    beforeClose(action, done) {
      //退款确定按钮之前 反馈原因
      if (action === 'confirm' && this.feedbackMessage == '') {
        if (this.radio == '1') {
          if (this.detailData.status == 4) {
            this.$toast('请填反馈内容');
            done(false);
            return;
          }
          this.$toast('请填写退款原因');
        } else if (this.radio == '2') {
          this.$toast('请填反馈内容');
        } else {
          // to do
        }
        done(false);
      } else if (action === 'confirm' && this.feedbackMessage != '') {
        if (this.detailData.refund_status != 0) {
          this.feedbackData();
        } else if (this.radio == '1') {
          this.refund_apply();
        } else {
          this.feedbackData();
        }
        done();
      } else {
        done();
      }
    },
    feedbackData() {
      //反馈信息 确定按钮
      axios
        .fetchPost('/api/order/feedback', {
          token: this.token,
          order_sn: this.detailData.order_sn,
          content: this.feedbackMessage,
        })
        .then((res) => {
          let data = res.data;
          if (data.code == 200) {
            this.feedbackMessage = '';
          }
          this.$toast(data.msg);
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    refund_apply() {
      //反馈信息，提交退款
      axios
        .fetchPost('/api/order/refund_apply', {
          token: this.token,
          order_sn: this.detailData.order_sn,
          content: this.feedbackMessage,
        })
        .then((res) => {
          let data = res.data;
          if (data.code == 200) {
            this.feedbackMessage = '';
          }
          this.$toast(data.msg);
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    do_accept() {
      //确认验收
      axios
        .fetchPost('/api/order/do_accept', {
          token: this.token,
          order_sn: this.detailData.order_sn,
        })
        .then((res) => {
          let data = res.data;
          if (data.code == 200) {
            this.$toast(data.msg);
            this.reload();
          } else {
            this.$toast(data.msg);
          }
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    cancelOrder() {
      this.orderShowFlag = true;
    },
    beforeCloseOrder(action, done) {
      //取消订单 确定 取消按钮
      if (action == 'confirm') {
        if (this.cancelOrderContent == '' && this.detailData.status != 0) {
          this.$toast('请填写取消原因');
          done(false);
          return;
        }
        //取消订单
        axios
          .fetchPost('/api/order/close', {
            token: this.token,
            order_sn: this.detailData.order_sn,
            refuse_reason: this.cancelOrderContent,
          })
          .then((res) => {
            let data = res.data;
            if (data.code == 200) {
              setTimeout(() => {
                this.reload();
              }, 500);
            }
            this.$toast(data.msg);
            done();
          })
          .catch((error) => {
            console.log('error :', error);
          });
      } else {
        done();
      }
    },
    warmWork(mid) {
      //提醒作业 // 提醒接单 // 提醒结束作业
      axios
        .fetchPost('/api/order/notice', {
          token: this.token,
          order_sn: this.detailData.order_sn,
          mid: mid,
        })
        .then((res) => {
          let data = res.data;
          this.$toast(data.msg);
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    lookMap() {
      //查看轨迹
      this.$router.push({
        path: '/flyDataOne',
        query: {
          order_sn: this.detailData.order_sn,
        },
      });
    },
    pay() {
      //支付订单
      this.$refs.pay.show = true;
      this.directPay = true;
    },
    check() {
      //待验收按钮
      this.dialog = true; //验收弹窗
      axios
        .fetchPost('/api/order/accept', {
          token: this.token,
          order_sn: this.detailData.order_sn,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.dialogDataMakeSure = res.data.data;
          }
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    beforeCloseMakeSure(action, done) {
      //确认验收
      let balance = this.dialogDataMakeSure.balance; //支付金额

      if (action == 'confirm') {
        if (this.confirmText == '确认支付') {
          this.$refs.pay.show = true;
          this.directPay = false;
          this.payMoney = balance;
          this.orderNumber = this.order_sn;
          done();
          return;
        }
        this.do_accept();
        done();
      } else {
        done();
      }
    },
    goToRefundDetail() {
      //去退款详情
      this.$router.push({
        path: '/refundDetail',
        query: {
          order_sn: this.detailData.order_sn,
        },
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.detail-wrap
  position relative
  background #efefef
  .top-header-bj
    position absolute
    width 100%
    top 0
    height 110px
    background #55CC99
    &.orange
      background #FF9922
    &.blue
      background #5B86E5
    &.fadeblue
      background #55ACCC
    &.green
      background #93CC55
    &.yellow
      background #CECC33
    &.fadegreen
      background #55CC99
  .top-header
    position relative
    z-index 1
    text-align left
    color #fff
    padding 0 12px
    padding-top 30px
    display flex
    justify-content space-between
    align-items center
    margin-bottom 20px
    line-height 1.2
    & > h4
      font-size 19px
      font-family Microsoft YaHei
      font-weight 400
      color rgba(255, 255, 255, 1)
    & >.time
      font-size 13px
  .order-experience
    background #fff
    margin 0 12px
    position relative
    z-index 1
    padding 14px
    text-align left
    border-radius 5px
    margin-bottom 10px
    .title
      color #656565
      font-size 14px
      line-height 22px
      margin-bottom 15px
    .btns
      display flex
      & > div
        width 75px
        height 25px
        text-align center
        line-height 25px
        border 1px solid rgba(153, 153, 153, 1)
        border-radius 25px
        margin-right 15px
        font-size 13px
        font-family Microsoft YaHei
        font-weight 400
        color rgba(102, 102, 102, 1)
      .pay
        background #FF9922
        color #fff
        border 1px solid #FF9922
      .btn5
        background #FF9922
        color #fff
        border 1px solid #FF9922
      .btn4
        background #EFEFEF
        & > i
          display inline-block
          vertical-align middle
          margin-top -2px
          font-size 13px
  .flyer-box
    background #fff
    text-align left
    padding-left 15px
    padding-top 15px
    padding-bottom 10px
    .title
      font-size 19px
      color #282828
      line-height 1.2
    .flyer-ul
      & > li
        display flex
        align-items center
        height 35px
        .name-title
          width 75px
          color #666666
          font-size 13px
        .img
          flex 1
          display flex
          align-items center
          // overflow hidden
          // border-radius 100%
          border none
          & > .img-box
            display block
            width 25px
            height 25px
            background green
            overflow hidden
            margin-right 15px
            border-radius 100%
            // border 1px solid #e5e5e5
            & > img
              display block
              width 100%
              height 100%
          .name
            margin-right 10px
            color #282828
            font-size 14px
          .tel
            font-size 14px
            color #55CC99
            & > i
              font-size 14px
              color #55CC99
              line-height 21px
        .tip
          display flex
          margin-right 14px
          color #FF0000
          align-items center
          font-size 13px
          width 90px
          & > i
            margin-right 10px
          .btn
            margin-left 10px
            border 1px solid rgba(153, 153, 153, 1)
            border-radius 25px
            font-size 13px
            color #666666
            padding 6px 11px
            line-height 1.1
    .team
      display flex
      height 35px
      align-items center
      .name-title
        color #666666
        width 75px
        font-size 13px
      .names
        flex 1
        font-size 14px
        color #282828
  .detail-content
    margin-top 10px
    text-align left
    &.top
      margin-top 59px
    .info-box
      background #fff
      display flex
      padding 10px 27px 10px 15px
      border-bottom 1px solid #e5e5e5
      .img-box
        width 62px
        height 62px
        overflow hidden
        margin-right 10px
        & > img
          display block
          width 100%
          height 100%
      .name
        flex 1
        font-size 14px
      .text
        text-align right
        font-size 12px
        line-height 20px
        .p1
          color #282828
        .p2
          color #999999
        .p3
          color #282828
          .number
            color #FF9922
  .address-list
    background #fff
    padding-top 15px
    // padding-left 12px
    // padding-right 28px
    &>.title
      font-size 14px
      font-family Microsoft YaHei
      font-weight 400
      color rgba(40, 40, 40, 1)
      line-height 1.1
      margin-bottom 2px
      padding-left 12px
      padding-right 28px
    .address-item
      padding-left 12px
      padding-right 28px
      position relative
      display flex
      align-items flex-start
      padding-bottom 9px
      border-bottom 1px solid #e5e5e5
      padding-top 13px
      &:last-child
        border none
      .van-ico
        font-size 15px
        color #656565
        margin-right 6px
      .address-text
        flex 1
        color #282828
        font-size 15px
        font-family Microsoft YaHei
        font-weight 400
        line-height 20px
    .time-box
      background #fff
      display flex
      padding-top 15px
      font-size 14px
      padding-bottom 14px
      border-bottom 1px solid #e5e5e5
      & > .title
        width 89px
        color #666666
        padding-left 12px
      .times
        flex 1
        .p1
          color #282828
        .p2
          color #989898
    .kids-box
      display flex
      padding-top 15px
      padding-right 12px
      border-bottom 1px solid #e5e5e5
      align-items flex-start
      padding-bottom 15px
      & > .title
        color #666666
        width 89px
        line-height 1.2
        font-size 14px
        padding-left 12px
      .content
        flex 1
        font-size 14px
        font-family Microsoft YaHei
        font-weight 400
        color rgba(40, 40, 40, 1)
        line-height 22px
        margin-top -4px
    .ps-box
      display flex
      padding-top 15px
      padding-right 12px
      border-bottom 1px solid #e5e5e5
      align-items flex-start
      padding-bottom 15px
      & > .title
        color #666666
        width 89px
        line-height 1.2
        font-size 14px
        padding-left 12px
      .content
        flex 1
        font-size 14px
        font-family Microsoft YaHei
        font-weight 400
        color rgba(40, 40, 40, 1)
        line-height 22px
        margin-top -4px
  .order-info-box
    margin-top 10px
    padding 13px 12px 10px
    background #ffffff
    & > .title
      line-height 1.2
      font-size 14px
      font-family Microsoft YaHei
      font-weight 400
      color rgba(40, 40, 40, 1)
      margin-bottom 13px
    & > .item
      display flex
      align-items flex-start
      margin-bottom 13px
      .babel
        width 76px
        font-size 13px
        line-height 1.2
        color #666666
      .text
        flex 1
        color #282828
        font-size 13px
        line-height 1.2
        .copy
          color #FF9922
          margin-left 15px
  .fly-area
    display flex
    background #ffffff
    margin-bottom 10px
    padding 15px 12px
    align-items center
    text-align left
    & > .img
      width 40px
      height 40px
      background url('./fly.png') no-repeat
      background-size 40px 40px
      margin-right 15px
    & > .list
      flex 1
      font-size 12px
      line-height 1.2
      &>.item
        display flex
        justify-content space-between
        margin-bottom 6px
        &:last-child
          margin-bottom 0
        .item-title
          font-size 12px
          color #282828
          .title-num
            font-size 14px
            font-style normal
            margin-left 5px
          .black
            font-size 14px
            font-style normal
            margin 0 5px
          .time
            color #666666
        .item-number
          font-size 14px
          display flex
          align-items center
          .down
            color #55CC99
            margin-right 5px
          .up
            color #FF9922
            margin-right 5px
            transform rotate(180deg)
          &>i
            font-style normal
          .orange
            color #FF9922
          .green
            color #55CC99
    .right-icon
      font-size 16px
      width 16px
      color #BEBEBE
      margin-left 35px
  /deep/.van-dialog__header
    margin-bottom 25px
  .noMargin
    /deep/.van-dialog__header
      margin-bottom 0
  .feedback-textarea-01
    border 1px solid #989898
    width 95%
    margin 0 auto 25px
  .radio-box
    display flex
    justify-content space-around
    margin-bottom 14px
  .refund-bar
    display flex
    align-items center
    height 50px
    text-align left
    padding-left 12px
    background #fff
    margin-bottom 10px
    &.top
      margin-top 59px
    .left
      font-size 14px
      color rgba(40, 40, 40, 1)
      flex 1
    .right
      font-size 14px
      color rgba(255, 153, 34, 1)
      margin-right 15px
    .icon
      font-size 13px
      width 30px
      text-align center
      &>i
        line-height 50px
        color #BEBEBE
  .feedback-bar
    margin-top 10px
    .right
      color #282828
      font-size 14px
  .dialog-box
    text-align left
    margin-top 20px
    padding 0 40px
    font-size 14px
    .p1
      color #989898
      margin-bottom 20px
    ul
      & > li
        display flex
        justify-content space-between
        margin-bottom 13px
        color #282828
        .orange
          color #FF9922
        .green
          color #55CC99
        .gray
          color #999999
</style>
